import { AxiosResponse } from 'axios';

import { AxiosWrapperService as axios } from '@qality/common-service';

import AuthenticateService from './AuthenticateService';

export default {
  async sendFeedback(
    feedbackPropertyName: string,
    message: string
  ): Promise<AxiosResponse> {
    const url = await AuthenticateService.authenticateByJWT(
      window.location.origin + '/feedback',
      'feedbackType=' + feedbackPropertyName + '&message=' + message
    );

    return axios.post(
      url,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  },
};
